module.exports = __webpack_public_path__ + "static/media/02_tn.a392cb4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/02_tn.jpg
// module id = 638
// module chunks = 0